import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ className = "", showText = true, size = "default", variant = "default" }) => {
  const sizeClasses = {
    small: "w-20 h-10",
    default: "w-32 h-16", 
    large: "w-40 h-20"
  };


  return (
    <Link to="/" className={`flex items-center space-x-3 ${className}`}>
      {/* Original Company Logo PNG */}
      <div className={`${sizeClasses[size]} flex items-center justify-center ${variant === "white" ? "bg-white rounded-lg p-2 shadow-lg" : ""}`}>
        <img 
          src="/images/logo.png" 
          alt="Amazon Filtration (K) Ltd Logo" 
          className="w-full h-full object-contain"
          onError={(e) => {
            console.log('Logo failed to load:', e.target.src);
            e.target.style.display = 'none';
          }}
        />
      </div>
    </Link>
  );
};

export default Logo;
